import React, { useState, useEffect } from "react";
import bgPattern from "./background_pattern.png";
import { Link} from 'react-router-dom';

export default function PrivacyPolicy() {
  const [lang, setLang] = useState("en");
  const [emailForShow, setEmailForShow] = useState("");
  useEffect(() => {
          // Собираем email динамически
          const user = "mail";
          const domain = "solar-spanish.com";
          setEmailForShow(`${user}@${domain}`);
      }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-neutral-50 p-3 flex flex-col items-center"
      style={{
        backgroundImage: `url(${bgPattern})`,
        backgroundRepeat: "repeat",
        backgroundSize: "auto",
      }}
    >
      
      <div className="w-full max-w-3xl bg-white shadow rounded-2xl p-6 border border-2">
        {/* Language Switcher */}
        <div className="flex justify-between mb-4">
          <Link to="/">
            <button class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-full">
              Go back
            </button>
          </Link>
          <select
            value={lang}
            onChange={(e) => setLang(e.target.value)}
            className="border rounded-xl px-3 py-2 bg-white shadow-sm"
          >
            <option value="en">English</option>
            <option value="ru">Русский</option>
          </select>
        </div>

        {/* English Version */}
        {lang === "en" && (
          <div>
            <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
            <p><strong>Last updated:</strong> February 10, 2025</p>
            <p className="mt-4">This Privacy Policy describes how Solar Spanish (“we”, “us”, or “our”) collects, uses, and protects your information when you use our mobile application (“Application”, “Service”).</p>
            <p className="mt-4">By using the Service, you agree to the collection and use of information in accordance with this Privacy Policy.</p>
            <h2 className="mt-4 font-bold">1. Information We Collect</h2>
            <h3 className="mt-2 font-bold">1.1 Personal Data</h3>
            <p>When registering or using the Service, we may collect the following information:</p>
            <ul>
              <li>- Email address (provided through Sign in with Apple or Google Sign-In)</li>
              <li>- First name</li>
              <li>- Authentication identifiers generated by Firebase Auth</li>
            </ul>
            <p className="mt-2">We do not collect or store user-uploaded images, documents, audio, or other personal files.</p>
            <h3 className="mt-2 font-bold">1.2 Usage Data</h3>
            <p>Usage Data is collected automatically by Firebase and may include:</p>
            <ul>
              <li>- IP address of your device</li>
              <li>- Device type and operating system</li>
              <li>- App version and device identifiers</li>
              <li>- Pages/screens visited within the app</li>
              <li>- Time and date of use</li>
              <li>- Diagnostic and crash data</li>
            </ul>
            <p className="mt-2">This data is used to improve performance, stability, and user experience.</p>
            <h2 className="mt-4 font-bold">2. How We Use Your Data</h2>
            <p>We may use personal and usage data for the following purposes:</p>
            <ul>
              <li>- To provide and maintain the Service</li>
              <li>- To manage your user account</li>
              <li>- To authenticate you through Firebase Auth</li>
              <li>- To sync your progress and settings across devices</li>
              <li>- To monitor and analyze usage (through Firestore standard logging)</li>
              <li>- To contact you if necessary (e.g., support requests)</li>
              <li>- To improve the Service and its features</li>
            </ul>
            <p className="mt-2">We do not use your data for advertising or marketing from third parties.</p>
            <h2 className="mt-4 font-bold">3. Third-Party Services We Use</h2>
            <p>The Service uses the following external providers:</p>
            <p className="mt-2 font-bold">Firebase Authentication</p>
            <p>Used to authenticate users via:</p>
            <ul>
              <li>- Sign in with Apple</li>
              <li>- Google Sign-In</li>
            </ul>
            <p className="mt-2">Firebase Auth receives your email address and may receive your name if provided.</p>
            <p className="mt-2 font-bold">Firebase Firestore</p>
            <p>Used to store:</p>
            <ul>
              <li>- Email</li>
              <li>- User’s name</li>
              <li>- Learning progress and app settings</li>
            </ul>
            <p className="mt-2">Firestore automatically processes device metadata (IP, timestamps) for security and operational purposes.</p>
            <p className="mt-2 font-bold">Firebase Storage</p>
            <p>Used only to host educational content such as images and audio files.</p>
            <p>No user-generated content is uploaded or stored.</p>
            <p className="mt-2 font-bold">Firebase Privacy Policy:</p>
            <a href="https://policies.google.com/privacy" target="_blank">https://policies.google.com/privacy</a>
            <h2 className="mt-4 font-bold">4. Data Storage and Retention</h2>
            <p>We store only the data necessary for the operation of the Service.</p>
            <p>Personal Data is retained for as long as your account exists or as required by law.</p>
            <p className="mt-2">You may request deletion of your data at any time (see Section 7).</p>
            <p className="mt-2">Usage Data is retained for shorter periods unless required for security or diagnostics.</p>
            <h2 className="mt-4 font-bold">5. Data Transfer</h2>
            <p>Your information may be processed in countries where Firebase servers or service providers operate.</p>
            <p>By using the Service, you consent to this transfer.</p>
            <p className="mt-2">We ensure that all reasonable steps are taken to protect your data in compliance with this Privacy Policy.</p>
            <h2 className="mt-4 font-bold">6. Children’s Privacy</h2>
            <p>The Service is not intended for users under 13 years old.</p>
            <p>We do not knowingly collect data from children under 13.</p>
            <p>If you believe such data has been collected, contact us and we will remove it.</p>
            <h2 className="mt-4 font-bold">7. Your Rights</h2>
            <p>You may:</p>
            <ul>
              <li>- Delete your account</li>
              <li>- Request deletion of your personal data</li>
              <li>- Update or change your account information</li>
              <li>- Request access to the data stored about you</li>
            </ul>
            <p className="mt-2">Contact us for any of these requests.</p>
            <h2 className="mt-4 font-bold">8. Changes to This Privacy Policy</h2>
            <p>We may update this Privacy Policy from time to time.</p>
            <p>Changes become effective once posted on this page.</p>
            <p>We will notify users of significant changes within the app.</p>
            <h2 className="mt-4 font-bold">9. Contact Us</h2>
            <p>Email: <a href={`mailto:${emailForShow}`} style={{ textDecoration: "none", color: "black" }}>{emailForShow}</a></p>
            <p>Website: <a href="https://solar-spanish.com">https://solar-spanish.com</a></p>
          </div>
        )}

        {/* Russian Version */}
        {lang === "ru" && (
          <div>
            <h1 className="text-3xl font-bold mb-4">Политика конфиденциальности</h1>
            <p><strong>Последнее обновление:</strong> 10 февраля 2025 г.</p>
            <p className="mt-4">Настоящая Политика конфиденциальности описывает, как приложение Solar Spanish («мы», «нас», «наше») собирает, использует и защищает ваши данные при использовании мобильного приложения («Приложение», «Сервис»).</p>
            <p className="mt-4">Используя Сервис, вы соглашаетесь с практиками обработки данных, описанными в этой Политике.</p>
            <h2 className="mt-4 font-bold">1. Какие данные мы собираем</h2>
            <h3 className="mt-2 font-bold">1.1 Персональные данные</h3>
            <p>При регистрации и использовании Приложения мы можем собирать:</p>
            <ul>
              <li>- Адрес электронной почты (через Sign in with Apple или Google Sign-In)</li>
              <li>- Имя пользователя</li>
              <li>- Удостоверяющие данные, создаваемые Firebase Auth</li>
            </ul>
            <p className="mt-2">Мы не храним пользовательские фото, документы, аудио или другие файлы.</p>
            <h3 className="mt-2 font-bold">1.2 Данные об использовании</h3>
            <p>Firebase автоматически собирает технические данные, включая:</p>
            <ul>
              <li>- IP-адрес устройства</li>
              <li>- Модель устройства и ОС</li>
              <li>- Версия приложения и уникальные идентификаторы</li>
              <li>- Страницы/экраны, посещённые в приложении</li>
              <li>- Время и дату использования</li>
              <li>- Диагностические и crash-данные</li>
            </ul>
            <p className="mt-2">Эта информация используется для улучшения работы приложения.</p>
            <h2 className="mt-4 font-bold">2. Как мы используем данные</h2>
            <p>Мы можем использовать данные для:</p>
            <ul>
              <li>- Обеспечения работы Сервиса</li>
              <li>- Управления вашим аккаунтом</li>
              <li>- Аутентификации пользователей через Firebase Auth</li>
              <li>- Синхронизации прогресса обучения</li>
              <li>- Аналитики использования (через Firestore)</li>
              <li>- Связи с вами при необходимости</li>
              <li>- Улучшения функциональности</li>
            </ul>
            <p className="mt-2">Мы не используем ваши данные для рекламы.</p>
            <h2 className="mt-4 font-bold">3. Сторонние сервисы</h2>
            <p>Приложение использует следующие сервисы:</p>
            <p className="mt-2 font-bold">Firebase Authentication</p>
            <p>Используется для входа:</p>
            <ul>
              <li>- Sign in with Apple</li>
              <li>- Google Sign-In</li>
            </ul>
            <p className="mt-2">Firebase получает ваш email и, при необходимости, имя.</p>
            <p className="mt-2 font-bold">Firebase Firestore</p>
            <p>Хранит:</p>
            <ul>
              <li>- email</li>
              <li>- имя пользователя</li>
              <li>- учебный прогресс и настройки пользователя</li>
            </ul>
            <p className="mt-2">Автоматически обрабатывает технические данные (IP, время доступа).</p>
            <p className="mt-2 font-bold">Firebase Storage</p>
            <p>Используется только для хранения учебных материалов (изображения, аудио).</p>
            <p>Пользовательские файлы не загружаются.</p>
            <p className="mt-2 font-bold">Политика конфиденциальности Firebase:</p>
            <a href="https://policies.google.com/privacy" target="_blank">https://policies.google.com/privacy</a>
            <h2 className="mt-4 font-bold">4. Хранение и удаление данных</h2>
            <p>Мы храним только данные, необходимые для работы Сервиса.</p>
            <p>Персональные данные сохраняются до удаления аккаунта или по требованиям закона.</p>
            <p className="mt-2">Вы можете запросить удаление данных в любой момент (см. раздел 7).</p>
            <h2 className="mt-4 font-bold">5. Передача данных</h2>
            <p>Ваши данные могут обрабатываться на серверах Firebase, расположенных за пределами вашей страны.</p>
            <p>Используя Приложение, вы даёте согласие на такую передачу.</p>
            <p className="mt-2">Мы принимаем меры для защиты вашей информации.</p>
            <h2 className="mt-4 font-bold">6. Конфиденциальность детей</h2>
            <p>Приложение не предназначено для детей младше 13 лет.</p>
            <p>Мы не собираем такие данные сознательно.</p>
            <p>Если это произошло, свяжитесь с нами — мы удалим информацию.</p>
            <h2 className="mt-4 font-bold">7. Ваши права</h2>
            <p>Вы можете:</p>
            <ul>
              <li>- удалять свой аккаунт</li>
              <li>- запрашивать удаление персональных данных</li>
              <li>- изменять данные профиля</li>
              <li>- запрашивать доступ к хранимой информации</li>
            </ul>
            <p className="mt-2">Для этого свяжитесь с нами.</p>
            <h2 className="mt-4 font-bold">8. Изменения в Политике</h2>
            <p>Мы можем обновлять Политику конфиденциальности.</p>
            <p>Изменения вступают в силу после публикации.</p>
            <p>О значимых изменениях мы уведомим пользователей в приложении.</p>
            <h2 className="mt-4 font-bold">9. Контакты</h2>
            <p>Email: <a href={`mailto:${emailForShow}`} style={{ textDecoration: "none", color: "black" }}>{emailForShow}</a></p>
            <p>Сайт: <a href="https://solar-spanish.com">https://solar-spanish.com</a></p>
          </div>
        )}
      </div>
    </div>
  );
}

